<!-- 手荷物ルールエリア(タイトル部分) -->

<div class="p-heading-area01">
  <h2 class="c-heading-2">
    <span class="c-text-with-tooltip">
      <span class="c-text-with-tooltip__text" [innerHTML]="'label.rule' | staticMsg"></span>
    </span>
  </h2>
</div>

<asw-mybooking-baggage-rules-dot
  [data]="dispData"
  [isPlanValid]="isPlanValid"
  *ngIf="!isError"
></asw-mybooking-baggage-rules-dot>

<!-- APIエラー時の表示 -->
<div *ngIf="isError" class="p-plan-table js-plan-table01-item" [ngClass]="{ 'grey-bg': !isPlanValid }">
  <div class="p-plan-table__contents">
    <div class="p-plan-table__scroll">
      <div class="p-plan-table__scroll-view">
        <div class="p-plan-table__scroll-inner js-plan-table01-scroll">
          <div class="c-form-element-error" role="alert" aria-live="polite">
            <p id="mybooking-baggage-rules-error" class="c-form-element-error__message">
              <em
                class="c-form-element-error__message-text"
                [innerHTML]="'label.canNotdisplayedBaggageRules' | staticMsg"
              ></em>
            </p>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
